import {Account} from "@/lib/types/accounts.ts";
import {MonitoringGroupLevel} from "@/lib/types/monitoring.ts";

export interface AccountBillingInfo {
  hasSubscription: boolean;
}

export enum Plan {
  Starter = "STARTER",
  Essential = "ESSENTIAL",
  Premium = "PREMIUM",
  Custom = "CUSTOM",
}

export enum BillingPeriod {
  MONTH = "MONTH",
  YEAR = "YEAR",
}

export interface AccountStats {
  name: string;
  max_monitoring_groups: number;
  max_monitoring_group_level: MonitoringGroupLevel;
  sms_credits: number;
  services: [number, number];
  sms: [number, number];
  sms_and_phone_alerts: [number, number];
  sp_sms: [number, number];
  phonecall: [number, number];
  api_checks: [number, number];
  rum_checks: [number, number];
  custom_checks: [number, number];
  group_checks: [number, number];
  cloudstatus_checks: [number, number];
  pagespeed_checks: [number, number];
  transaction_checks: [number, number];
  basic_checks: [number, number];
  advanced_checks: [number, number];
  multi_users: [number, number];
  dashboards: [number, number];
  statuspages: [number, number];
  statuspages_subscriptions: [number, number];
  reports: [number, number];
  scheduled_reports: [number, number];
  rum_requests: [number, number];
  private_locations: [number, number];
  main_account_plan?: string;
  account?: Account;
  locations?: [number, number];
  statuspages_external_user?: [number, number];
}

export enum PaymentMethodType {
  CREDIT_CARD = "CREDIT_CARD",
  PAYPAL = "PAYPAL",
}

export interface PaymentMethod {
  pm_type?: PaymentMethodType;
  type?: string;
  img?: string;
  suffix?: string;
  expiration_date?: string;
  is_expired?: boolean;
  email?: string;
}

export interface BillingData {
  cardholder_name?: string;
  company_name?: string;
  billing_name?: string;
  billing_email?: string;
  address_1?: string;
  address_2?: string;
  country?: string;
  city?: string;
  state?: string;
  zipcode?: string;
  additional_info?: string;
  phone?: string;
}

export interface PaymentMethodUpdate extends BillingData {
  payment_method: PaymentMethodType;
  payment_method_nonce: string;
  recaptcha_response_token?: string;
}

export interface Discount {
  title: string;
  percent: number;
  value: number;
  mini_quote: boolean;
  is_promo: boolean;
  recurring: boolean;
  highlight: boolean;
}

export interface CalculationUnitPrice {
  name: string;
  price: number;
}

export interface CalculatedBillingDataMonthly {
  price_monthly: number;
}

export interface CalculatedBillingData extends CalculatedBillingDataMonthly {
  added_cost: number;
  added_cost_full: number;
  base_plan: string; // This is a verbose name of the plan
  base_price: number;
  base_price_subtotal: number;
  discounts: Discount[];
  monthly_subtotal: number;
  total_due_today: number;
  units_prices: CalculationUnitPrice[];
}

export interface AddedValue {
  limit_field: string;
  amount: number;
}

export interface Invoice {
  id: number;
  transaction_id: string;
  created_at: string;
  amount: number;
  is_successful: boolean;
  type: string;
  legacy_plan?: string;
  status: string;
  source?: string;
  period_start?: string;
  period_end?: string;
  payment_instrument_type: string;
  processor_response_code: string;
  processor_response_type: string;
  processor_response_text: string;
  credit_card_type: string;
  credit_card_suffix: string;
  credit_card_slug: string;
  paypal_account: string;
}
